<div *ngIf="isBrowser">
  <img  *ngIf="isIMG; else showSVG" [src]="url" class="{{ clazz }}" alt="{{ alt }} " />
  <ng-template #showSVG>
    <div class="svg {{ clazz }}" [innerHTML]="svg"></div>
  </ng-template>
</div>

